<template><div><dt-notice kind="warning" title="Use DtText over CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Reach for the <a href="/components/text" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtText</a> component before considering any typography utility.
</dt-notice>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-fw-{n}</code> to change an element's font-weight.</p>
<code-example source-code='&lt;p class=&quot;d-fw-{className}&quot;&gt;...&lt;/p&gt;'>
<div class="d-d-grid d-g-200 d-ai-center" style="grid-template-columns: 11rem 1fr">
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-normal</div>
  <div><p class="d-fw-normal">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-medium</div>
  <div><p class="d-fw-medium">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-semibold</div>
  <div><p class="d-fw-semibold">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code d-ws-nowrap">.d-fw-bold</div>
  <div><p class="d-fw-bold">The quick brown fox jumps over the lazy dog.</p></div>
</div>
</code-example>
<h2 id="variables" tabindex="-1" class="d-docsite--header-2">Variables <a class="header-anchor d-link d-docsite--link d-link" href="#variables" aria-hidden="true">#</a></h2>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
          <tr>
              <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Variable</div></th>
              <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
          </tr>
      </thead>
      <tbody>
        <tr v-for="{ name, output } in weight">
          <th scope="row" class="d-code--sm d-docsite-code">var(--dt-font-weight-{{ name }})</th>
          <td class="d-code--sm">{{ output }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ name, class: className, output } in weight">
        <th scope="row" class="d-code--sm d-docsite-code">
          .d-fw-{{ className }}
        </th>
        <td class="d-code--sm">
          font-weight: var(--dt-font-weight-{{ name }}) !important;
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { weight } from '@data/type.json';
  import ClampedTableWrapper from '@baseComponents/ClampedTableWrapper.vue';
</script>